// this function should mimick the behavior of compose from redux. 
// Instead of writing this:
//     `func1(func2(func3(func4))))`
// We can write this:
//     `compose(func1, func2, func3, func4)`
export const compose = (...funcs: Function[]) => funcs.reduce((a, b) => (...args: any[]) => a(b(...args)))
